import { AccountActionsPlacementContext } from '@components/Header/contexts/AccountActionsPlacementContext';
import { AccountActions } from '@components/Header/components/AccountActions';
import { ReactNode, useEffect, useState } from 'react';
import { useModalContext } from '@providers/ModalProvider';
import { useLocation } from 'react-router-dom';
import { NavigationToggle } from '@components/NavigationToggle';
import { NavigationDrawer } from '@components/NavigationDrawer';
import { useMediaQuery } from 'app/hooks/useMediaQuery';
import { Sidebar } from '../Routes/components/Sidebar';
import { EnvironmentBadge } from '@components/EnvironmentBadge';
import { EnvironmentBadgeDemo } from '@components/EnvironmentBadge/variations/EnvironmentBadgeDemo';
import { EnvironmentBadgeDev } from '@components/EnvironmentBadge/variations/EnvironmentBadgeDev';
import { getEnvironmentFromHostname } from '@helpers/getEnvironmentFromHostname';

type TProps = {
  children: ReactNode;
};

export const AuthenticatedAppShell = ({ children }: TProps) => {
  const [navigationOpen, setNavigationOpen] = useState(false);
  const desktop = useMediaQuery('(min-width: 1280px)');
  const location = useLocation();
  const { isModalOpen } = useModalContext();
  const environment = getEnvironmentFromHostname(window.location.hostname);

  useEffect(() => {
    if (isModalOpen) {
      setNavigationOpen(false);
    }
  }, [isModalOpen]);

  useEffect(() => setNavigationOpen(false), [location.key, desktop]);

  return (
    <>
      <div className="relative flex min-h-full min-w-0 w-full flex-col xl:ml-[240px] xl:w-[calc(100%-240px)]">
        <div className="app-shell-bar sticky top-0 z-40 flex items-center justify-between gap-2 border-b border-border bg-surface px-4 xl:hidden">
          <div className="flex items-center gap-2">
            <NavigationToggle expanded={navigationOpen} onClick={() => setNavigationOpen((open) => !open)} />
            {environment === 'staging' ? <EnvironmentBadge label="STAGING" /> : null}
            {environment === 'demo' ? <EnvironmentBadgeDemo label="DEMO" /> : null}
            {environment === 'dev' ? <EnvironmentBadgeDev label="DEV" /> : null}
          </div>
          {!desktop && <AccountActions />}
        </div>
        <AccountActionsPlacementContext.Provider value="navigation">{children}</AccountActionsPlacementContext.Provider>
      </div>
      {desktop ? (
        <nav aria-label="Main navigation" className="fixed inset-y-0 left-0 z-20 w-[240px]">
          <Sidebar />
        </nav>
      ) : (
        <NavigationDrawer open={navigationOpen} onClose={() => setNavigationOpen(false)}>
          <Sidebar />
        </NavigationDrawer>
      )}
    </>
  );
};
